import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import { NotificationCard } from 'core/components/notification-card';
import Checkbox from 'core/components/checkbox';
import closeIcon from 'core/assets/svg/x.svg';
import { Label } from 'core/components/label';
import { ActionButton } from 'core/components/action-button';
import useStyles from './confirm-remove-car-modal.styles';

const ConfirmRemoveCarModal = ({ open, onClose, onRemove, car }) => {
  const classes = useStyles();
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState(false);

  const handleClose = () => {
    setAccepted(false);
    setError(false);
    onClose();
  };

  const handleSubmit = () => {
    if (!accepted) {
      setError(true);
      return;
    }
    onRemove();
    handleClose();
  };

  const carLabel = `${car?.year || ''} ${car?.make || ''} ${car?.model || ''}`.trim() || 'Vehicle';

  return (
    <Dialog open={open} onClose={handleClose} classes={{ paper: classes.container }}>
      <ActionButton type="edit" size="big" icon={closeIcon} className={classes.closeButton} onClick={handleClose} />
      <DialogTitle>
        <Label className={classes.title}>Remove Vehicle</Label>
      </DialogTitle>
      <DialogContent>
        <p className={classes.text}>You are about to remove a vehicle from this policy.</p>
        <Grid container>
          <Grid item xs={6} className={classes.carInfo}>
            <Label type="infoLabel">Vehicle</Label>
            <Grid item>{carLabel}</Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <NotificationCard type="light" header="Please keep in mind">
              If there is a loss prior to the removal date, this may affect claim eligibility. Please verify there are
              no open or pending claims on this vehicle before proceeding.
            </NotificationCard>
          </Grid>
          <Grid item xs={12}>
            <Checkbox
              id="remove-car-attestation"
              mode="light"
              name="remove-car-attestation"
              label="I acknowledge the above and wish to proceed with removing this vehicle."
              value={accepted}
              onChange={(e) => {
                setAccepted(e.target.checked);
                setError(false);
              }}
              error={error}
              className={classes.checkbox}
            />
          </Grid>
        </Grid>
        <div className={classes.footer}>
          <Button type="button" variant="contained" color="primary" className={classes.button} onClick={handleSubmit}>
            Remove Vehicle
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

ConfirmRemoveCarModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  car: PropTypes.shape({
    year: PropTypes.number,
    make: PropTypes.string,
    model: PropTypes.string
  })
};

ConfirmRemoveCarModal.defaultProps = {
  car: {}
};

export default ConfirmRemoveCarModal;
